export default {
  fontSize: {
    jp: '文字サイズ',
    en: 'Font Size',
  },
  translate: {
    jp: 'JP → EN',
    en: '英語 → 日本語',
  },
  scroll: {
    jp: 'メニュー',
    en: 'Menu',
  },
}
